import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/navbar';
import './planview.css';

const PlanView = () => {
  const { id } = useParams();
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState('');
useEffect(() => {
  axios.get(`${process.env.REACT_APP_API_URL}/getPlanById/${id}`)
    .then(response => {
      // Check if data is a plan object directly
      if (response.data && response.data._id) {
        setPlan(response.data);
      } else {
        setError('Plan not found.');
      }
    })
    .catch(() => setError('Something went wrong!'));
}, [id]);



  if (error) {
    return (
      <div>
        <Navbar />
        <div className="error-container">
          <h3>{error}</h3>
          <Link to="/plans" className="btn btn-primary">Go Back</Link>
        </div>
      </div>
    );
  }

  if (!plan) {
    return (
      <div>
        <Navbar />
        <div className="loading text-center mt-5">Loading...</div>
      </div>
    );
  }

  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <section className="planview-banner">
        <div className="container text-center">
          <h1>{plan.planName}</h1>
          <p className="text-muted">{plan.planType}</p>
        </div>
      </section>

      {/* Plan Details */}
      <section className="planview-details">
        <div className="container">
          <div className="plan-card shadow">
            <div className="plan-header">
              <h2>{plan.planName}</h2>
              <span className="plan-price">
                ₹{plan.planPrice === 'Free' ? '0' : parseInt(plan.planPrice).toLocaleString('en-IN')}
              </span>
            </div>

            <div className="plan-features">
              <h4>What's Included:</h4>
              {plan.planList && plan.planList.length > 0 ? (
                <ul>
                  {plan.planList.map((item, idx) => (
                    <li key={idx}><i className="fas fa-check-circle text-success me-2"></i>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted">No additional features listed for this plan.</p>
              )}
            </div>

            <div className="text-center mt-4">
              <Link to="/plans" className="btn btn-secondary me-3">Back to Plans</Link>
              <button className="btn btn-primary">Choose This Plan</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PlanView;
